import PropTypes from 'prop-types';
import Button from '@mui/material/Button';

import { getMessage } from '@gef-ui/localization/messages';
import CirclePlus from '@gef-ui/material-icons/CirclePlus';

export const PlusMore = ({ value, onClick }) => {
	return (
		value > 0 && (
			<Button
				sx={{ width: 'max-content', justifyContent: 'left' }}
				variant="text"
				startIcon={<CirclePlus />}
				onClick={onClick}
			>
				{getMessage('common:more', { count: value })}
			</Button>
		)
	);
};

PlusMore.propTypes = {
	onClick: PropTypes.func,
	value: PropTypes.number,
};

export default PlusMore;
